// A buzz and a tone together, so every event that vibrates also sounds and the two never drift
// apart. Screens call these, never haptic() or the play functions on their own.
import { haptic } from "./haptics";
import { playMinus, playStar, playTick } from "./sound";

/** Any tap that does something: a point added, a toggle, a step. */
export function tapFeedback(pattern: number | number[] = 10): void {
  haptic(pattern);
  playTick();
}

/** Points taken away, once the hold completes. */
export function minusFeedback(): void {
  haptic([30, 40, 30]);
  playMinus();
}

/** A star won, with the shooting star. */
export function starFeedback(): void {
  haptic([40, 60, 40, 60, 80]);
  playStar();
}
